/**
 *
 * ExpireTime
 *
 */

import React from 'react';

import * as S from './styles';

/* eslint-disable react/prefer-stateless-function */
class ExpireTime extends React.PureComponent {
    render() {
        const { hours, minutes, seconds, id } = this.props;

        const colorSeconds = seconds > 0 && minutes < 1 ? 'red' : 'grey';

        const colorMinutes = hours <= 0 && minutes <= 5 && minutes > 0 ? 'orange' : colorSeconds;

        const colorHours = colorMinutes;

        const strHours = hours > 9 ? `${hours}` : `0${hours}`;
        const strMinutes = minutes > 9 ? `${minutes}` : `0${minutes}`;
        const strSeconds = seconds > 9 ? `${seconds}` : `0${seconds}`;

        return (
            <S.ExpireTime id={id}>
                <S.Title>Your tickets are being held for:</S.Title>
                <S.Clock color={colorHours}>
                    <S.Group>
                        <S.GroupValue>{strHours}</S.GroupValue>
                        <S.GroupLabel>Hours</S.GroupLabel>
                    </S.Group>
                    <S.Group className="clock-divider">
                        <S.GroupValue>:</S.GroupValue>
                    </S.Group>
                    <S.Group>
                        <S.GroupValue>{strMinutes}</S.GroupValue>
                        <S.GroupLabel>Minutes</S.GroupLabel>
                    </S.Group>
                    <S.Group className="clock-divider">
                        <S.GroupValue>:</S.GroupValue>
                    </S.Group>
                    <S.Group>
                        <S.GroupValue>{strSeconds}</S.GroupValue>
                        <S.GroupLabel>Seconds</S.GroupLabel>
                    </S.Group>
                </S.Clock>
            </S.ExpireTime>
        );
    }
}

export default ExpireTime;
